import { useEffect, useMemo } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import splitCountriesToDefaultAndOther from "../../utils/splitCountriesToDefaultAndOther";
import useOrderFormik from "../useOrderFormik";

const fieldName = OrderFields.DESTINATION_COUNTRY;

const useDefaultCountryTo = (): void => {
  const {
    values: { [fieldName]: currentValue },
    setFieldValue,
    setFieldError,
  } = useOrderFormik();

  const {
    dynamicData: { countriesTo },
  } = useOrderData();

  const defaultCountryCodeToSelect = useMemo(() => {
    const { defaultCountry, otherCountries } = splitCountriesToDefaultAndOther(countriesTo);
    return defaultCountry?.code || otherCountries?.[0]?.code;
  }, [countriesTo]);

  // If current value is not set, and there are available values - set to the first not disabled value as default
  useEffect(() => {
    if (!currentValue && defaultCountryCodeToSelect) {
      setFieldValue(fieldName, defaultCountryCodeToSelect);
      setFieldError(fieldName, undefined);
    }
  }, [currentValue, defaultCountryCodeToSelect, setFieldError, setFieldValue]);

  // Check if current value is disabled, if yes, set current value to the first not disabled value
  useEffect(() => {
    if (currentValue && !countriesTo.find(({ code }) => code === currentValue)) {
      setFieldValue(fieldName, defaultCountryCodeToSelect || null);
      setFieldError(fieldName, undefined);
    }
  }, [countriesTo, currentValue, defaultCountryCodeToSelect, setFieldError, setFieldValue]);
};
export default useDefaultCountryTo;
